import {Component, HostListener, OnInit} from '@angular/core';
import {FooterService} from '../../../services/footer.service';

@Component({
  selector: 'app-exchange-rates',
  templateUrl: './exchange-rates.component.html',
  styleUrls: ['./exchange-rates.component.css']
})
export class ExchangeRatesComponent implements OnInit {

  footerHeight: number;

  constructor(private footerService: FooterService) { }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    setTimeout(() => {
      this.footerHeight = this.footerService.getFooterHeight();
    }, 500);
  }

  ngOnInit(): void {
    this.footerHeight = this.footerService.getFooterHeight();
  }
}
